var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEfficiencyOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "efficiencyOne"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.431,
    cy: 30.126,
    r: 29.946,
    style: {
      fill: "#4888ad"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.91,17.646c2.504,3.494 3.978,7.776 3.978,12.399c0,11.768 -9.554,21.323 -21.322,21.323c-2.686,-0 -5.257,-0.498 -7.625,-1.406",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.693,47.871l2.349,1.869",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.188,44.749l2.316,1.844",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.448,42.628c1.611,-1.99 3.774,-1.179 6.561,0.985l-4.122,5.295c-2.926,-2.37 -4.09,-4.241 -2.439,-6.28Z",
    style: {
      fill: "#4888ad",
      stroke: "#fff",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.477,12.152l-2.346,-1.873",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.976,15.27l-2.313,-1.848",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.712,17.401c-1.615,1.988 -3.777,1.173 -6.559,-0.997l4.132,-5.287c2.921,2.376 4.081,4.249 2.427,6.284Z",
    style: {
      fill: "#4888ad",
      stroke: "#fff",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.976,42.095c-2.355,-3.429 -3.733,-7.58 -3.733,-12.05c-0,-11.769 9.554,-21.323 21.323,-21.323c2.413,-0 4.734,0.402 6.898,1.142",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.821,38.888c-0,-0 0.382,-3.994 -1.965,-7.552c-2.31,-3.502 -2.599,-5.345 -2.677,-8.212c-0.12,-4.422 2.869,-8.439 9.07,-8.607c5.93,-0.16 9.256,4.124 9.344,8.415c0.145,6.993 -4.038,6.883 -4.473,15.994c-0.01,0.203 -9.296,0.14 -9.299,-0.038Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.435,41.163c2.654,0.075 5.321,0.091 7.999,0.053",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.435,42.856c2.636,0.077 5.3,0.098 7.999,0.053",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.435,44.441l7.999,0.053",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.302,46.064l6.169,-0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiencyOne);
export default __webpack_public_path__ + "static/media/efficiencyOne.87654c791af36a1d00371002d7b5f8d7.svg";
export { ForwardRef as ReactComponent };